import Vue from 'vue'
import Router from 'vue-router'

const Home = resolve => require(['@/components/home/Home'], resolve)

const About = resolve => require(['@/components/about/About'], resolve)
const AboutInfo = resolve => require(['@/components/about/AboutInfo'], resolve)
const AboutTimeline = resolve => require(['@/components/about/AboutTimeline'], resolve)

// const Skills = resolve => require(['@/components/skills/Skills'], resolve)

const Project = resolve => require(['@/components/project/Project'], resolve)

const Contact = resolve => require(['@/components/contact/Contact'], resolve)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/about',
      component: About,
      redirect: '/about/info',
      children: [
        {
          path: '/about/info',
          component: AboutInfo
        },
        {
          path: '/about/timeline',
          component: AboutTimeline
        }
      ]
    },
    {
      path: '/project',
      name: 'project',
      component: Project
    },
    {
      path: '/contact',
      name: 'contact',
      component: Contact
    }
  ]
})

// Scroll to top when switching components
router.beforeEach(function (to, from, next) {
  window.scrollTo(0, 0)
  next()
})

Vue.use(Router)

export default router



// WEBPACK FOOTER //
// ./src/router/index.js